import React from 'react';
import { IconWrapper, NoBreakWrapper } from './StyledAttributeIcon';
import { AttributeType } from '_utils/helpers/attributeType';
import { StatusType } from '_utils/helpers/statusType';
import {
  Book,
  Closed,
  Completed,
  Cost,
  InProgress,
  Marker,
  OpenForFeedback,
  Planned,
  Time,
  UnderReview
} from '_utils/icons';
import PropTypes from 'prop-types';

const icons = {
  [AttributeType.location]: Marker,
  [AttributeType.cost]: Cost,
  [AttributeType.time]: Time
};

const statusIcons = {
  [StatusType.book]: Book,
  [StatusType.underReview]: UnderReview,
  [StatusType.inProgress]: InProgress,
  [StatusType.planned]: Planned,
  [StatusType.closed]: Closed,
  [StatusType.open]: OpenForFeedback,
  [StatusType.completed]: Completed
};

const AttributeIcon = ({ attribute }) => {
  if (!attribute) {
    return null;
  }

  let Icon = null;
  let classNameAttribute = attribute.type;
  let classNameStatus = '';

  if (attribute.type === AttributeType.statusIcon) {
    Icon = statusIcons[attribute.value];
    classNameStatus = attribute.value;
  } else {
    Icon = icons[attribute.type];
  }

  if (!Icon) {
    // console.log('no icon found for ', attribute.type);
    return null;
  }

  return (
    <NoBreakWrapper>
      <IconWrapper className={`${classNameAttribute} ${classNameStatus}`}>
        <Icon ariaHidden={true} />
      </IconWrapper>
      &#65279;
    </NoBreakWrapper>
  );
};

AttributeIcon.propTypes = {
  attribute: PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.string
  })
};

export default AttributeIcon;
